import { AngularComponentsModule, GoabText } from '@abgov/angular-components';
import { ResourcePipe } from '@ala/common-ui';
import { CommonModule } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  OnInit,
} from '@angular/core';
import { NotificationService } from '@libs/services/notification.service';
import { CapacityReportListStateService } from '../../../../services-v2/states/capacity-report-list.state.service';
import { NoReportsFoundComponent } from '../../../error/components/no-reports-found/no-reports-found.component';
import { CapacityReportingGrid } from '../../components/capacity-reporting-grid/capacity-reporting-grid';
import { CapacityReportingModal } from '../../components/capacity-reporting-modal/capacity-reporting-modal';
import { CapacityReportingSearch } from '../../components/capacity-reporting-search/capacity-reporting-search';

@Component({
  selector: 'app-capacity-reporting-page',
  imports: [
    CommonModule,
    AngularComponentsModule,
    ResourcePipe,
    GoabText,
    NoReportsFoundComponent,
    CapacityReportingModal,
    CapacityReportingSearch,
    CapacityReportingGrid,
  ],
  templateUrl: './capacity-reporting-page.html',
  styleUrl: './capacity-reporting-page.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CapacityReportingPage implements OnInit {
  pageId = 'VIEWENTRIES';
  private readonly _capacityReportState = inject(
    CapacityReportListStateService
  );
  private readonly _notificationService = inject(NotificationService);

  hasCapacityReports = this._capacityReportState.hasCapacityReports;

  async ngOnInit(): Promise<void> {
    this._notificationService.progressIndicatorMessage.set(
      'Loading capacity reports...'
    );
    this._notificationService.isProgressIndicator.set(true);
    await this._capacityReportState.loadCapacityReports();
    this._notificationService.isProgressIndicator.set(false);
  }
}
